import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootEl = document.getElementById("root");
// Strip the static SEO fallback (it was for crawlers / first-byte readers — React owns the DOM from here)
const seoFallback = document.getElementById("seo-fallback");
if (seoFallback) seoFallback.remove();

const wasPrerendered = document.documentElement.dataset.prerendered === "true";

const tree = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (wasPrerendered) {
  // Pre-rendered HTML present — hydrate in place so the rendered DOM stays painted
  ReactDOM.hydrateRoot(rootEl, tree);
} else {
  const root = ReactDOM.createRoot(rootEl);
  root.render(tree);
}
